import React, { useState, useEffect } from 'react';
import '../styles/staffPin.css';

/**
 * Shows who is currently PIN-identified on this till, in the footer beside the Floor Plan View
 * toggle - the same place and wording as the local build. Renders nothing when nobody is
 * identified, which is every restaurant that has not switched staff PIN login on.
 *
 * Reads localStorage on the same `staffPinValidated` / `staffSwitchRequested` window events
 * StaffPinGate and Header already dispatch, so it stays in sync with the PIN flow without any
 * prop drilling or shared context.
 */
const ActiveStaffBadge = () => {
  const [name, setName] = useState(() => localStorage.getItem('active_staff_name') || '');
  const [role, setRole] = useState(() => localStorage.getItem('active_staff_role') || '');

  useEffect(() => {
    const onValidated = () => {
      setName(localStorage.getItem('active_staff_name') || '');
      setRole(localStorage.getItem('active_staff_role') || '');
    };
    const onSwitchRequested = () => {
      setName('');
      setRole('');
    };
    window.addEventListener('staffPinValidated', onValidated);
    window.addEventListener('staffSwitchRequested', onSwitchRequested);
    return () => {
      window.removeEventListener('staffPinValidated', onValidated);
      window.removeEventListener('staffSwitchRequested', onSwitchRequested);
    };
  }, []);

  if (!name) {
    return null;
  }

  return (
    <span className="activeStaffBadge">
      Active Staff: {name}{role ? ` (${role})` : ''}
    </span>
  );
};

export default ActiveStaffBadge;
